import { Banner, Bullets, FlexContainer, Sizes, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';

const ToPayInformation = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  return (
    <Styled.Container direction="column" gap="dimension_16" fullWidth>
      <Banner
        id="to-pay-information"
        label={t('PreFiling.years.topay.title')}
        description={t('PreFiling.years.topay.description')}
        mode="default"
        layout="embed"
        position="vertically"
        titleSize={Sizes.XS}
        hasIcon={false}
      />
      <Styled.WrapContainer size="M">
        <FlexContainer direction="column" gap="dimension_08" align="center">
          <Text type="paragraphs" size="M_XL_S" color="dark">
            {t('PreFiling.years.topay.information.title')}
          </Text>
          <Bullets
            bullets={[
              {
                text: t('PreFiling.years.topay.information.bullet.1'),
              },
              {
                text: t('PreFiling.years.topay.information.bullet.2'),
              },
              {
                text: t('PreFiling.years.topay.information.bullet.3'),
              },
            ]}
            icon={{
              type: 'IconTickCleanSDark',
            }}
            spacing="S"
          />
        </FlexContainer>
      </Styled.WrapContainer>
    </Styled.Container>
  );
};

export default ToPayInformation;
